/*
 * Copyright (c) 2024. BrightNight. All rights reserved.
 * Unauthorized copying of this file, via any medium is strictly prohibited.
 * Proprietary and confidential.
 */
import { atom } from 'jotai';
import type { DrawnLayers } from './maps/types';

export const drawnLayersAtom = atom<DrawnLayers>({});

export const collapsedFieldsetAtom = atom<Record<string, boolean>>({});
